import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULTS = [
  { quote: "We found three qualified linen suppliers in under 10 minutes, something that used to take weeks of cold calls.", attribution: "Hotel Procurement Manager, Queensland" },
  { quote: "Finally a directory that actually has Australian suppliers. No more chasing international wholesalers.", attribution: "Accommodation Buyer, Victoria" },
  { quote: "Sent one request and had two responses the same day. Exactly what we needed.", attribution: "Procurement Lead, New South Wales" },
];

// One anonymous buyer quote per visit, random from the Admin-managed list enabled for `page`. Renders nothing if none.
export default function RotatingTestimonial({ page = "home", className = "", light = false }) {
  const [t, setT] = useState(null);
  useEffect(() => {
    let alive = true;
    const pick = (list) => { if (!alive || !list.length) return; const i = Math.floor(Math.random() * list.length); setT({ i, ...list[i] }); };
    api.get(`/testimonials?page=${page}`).then(({ data }) => pick(data.items || [])).catch(() => pick(page === "home" ? DEFAULTS : []));
    return () => { alive = false; };
  }, [page]);
  if (!t) return null;
  return (
    <figure className={`max-w-3xl border-l-4 ${light ? "border-[#F0C866]" : "border-[#264839]"} pl-6 md:pl-8 py-1 ${className}`} data-testid="home-testimonial" data-quote-index={t.i} data-quote-id={t.id} data-page={page}>
      <blockquote className={`font-serif text-xl md:text-2xl leading-snug ${light ? "text-white" : "text-[#11211A]"}`} data-testid="home-testimonial-quote">“{t.quote}”</blockquote>
      <figcaption className={`mt-4 text-xs uppercase tracking-[0.2em] ${light ? "text-white/60" : "text-[#7D8C85]"}`} data-testid="home-testimonial-attribution">{t.attribution}</figcaption>
    </figure>
  );
}
